import { FC } from 'react';
import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import Table from '@cloudscape-design/components/table';
import Header from '@cloudscape-design/components/header';
import Link from '@cloudscape-design/components/link';
import { Icon } from '@cloudscape-design/components';

interface DocumentItem {
  title: string;
  icon: 'folder' | 'file' | 'user-profile';
  link: string;
}

const DocumentsSection = () => {
  const documentItems: DocumentItem[] = [
    {
      title: 'Gravion Audit Tool Wiki',
      icon: 'folder',
      link: 'https://w.amazon.com/bin/view/Global-Standards-Tech-Team/Gravion/',
    },
    {
      title: 'Gravion Training',
      icon: 'file',
      link: 'https://atoz.amazon.work/m/learn/transcriptdetail?trainingId=TCRLERN20251020192043a8cdf452&trainingLms=LEARN',
    },
    {
      title: 'Standard Operating Procedure',
      icon: 'file',
      link: 'https://policy.a2z.com/docs/707845/publication',
    },
    {
      title: 'Admin User List',
      icon: 'user-profile',
      link: '#',
    },
  ];

  const columnDefinitions = [
    {
      id: 'title',
      header: 'TITLE',
      cell: (item: DocumentItem) => (
        <Box
          data-testid={`document-item-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
        >
          <Icon
            name={item.icon}
            variant="link"
            data-testid={`document-icon-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
          />
          <Box
            display="inline"
            margin={{ left: 's' }}
            data-testid={`document-title-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
          >
            {item.title}
          </Box>
        </Box>
      ),
    },
    {
      id: 'action',
      header: 'ACTION',
      cell: (item: DocumentItem) => (
        <Link
          href={item.link}
          external
          data-testid={`document-link-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
        >
          View
        </Link>
      ),
    },
  ];

  return (
    <Container
      data-testid="documents-container"
      header={
        <Header variant="h2" data-testid="documents-header">
          Documentation & References
        </Header>
      }
    >
      <Table
        data-testid="documents-table"
        variant="embedded"
        columnDefinitions={columnDefinitions}
        items={documentItems}
      />
    </Container>
  );
};

export default DocumentsSection;
